namespace TabAurous.Common {
    export interface MarkUpResponse extends Serenity.ServiceResponse {
        Entity?: MarkUpResponseEntity;
    }
}
